export default {"src":"/_next/static/media/multiplier.96e1cb63.svg","height":31,"width":99,"blurWidth":0,"blurHeight":0};